import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { ravelComponentPath } from '../../../../common/RavelComponentPath.js';

export class RavelSlider2 extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container {
            position: absolute;
            cursor: pointer;
            user-select: none;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        #slider-background {
            position: absolute;
            width: 100%;
            height: 100%;
        }
        #slider-handle {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0px;
        }
        #sensor {
            position: absolute;
            border-radius: 24px;
        }
        .pixelArt {
            position: absolute;
        }
        .transparent {
            background-color: rgba(255, 255, 255, 0);
        }
        .light-pixel {
            background-color: #aaaaaa;
        }
        .dark-pixel {
            background-color: #000000;
        }
        .color-pixel {
            background-color: #FFFF00;
        }
        #handle-shadow {
            opacity: 0.5;
            background-color: #000000;
        }
        #handle-container {
            position: absolute;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
        <div id="sensor"></div>
        <div id="slider-background">
            <div id="top-side" class="dark-pixel pixelArt"></div>
            <div id="left-side" class="dark-pixel pixelArt"></div>
            <div id="left-margin" class="light-pixel pixelArt"></div>
            <div id="right-margin" class="light-pixel pixelArt"></div>
            <div id="right-side" class="dark-pixel pixelArt"></div>
            <div id="bottom-side" class="dark-pixel pixelArt"></div>            
            <div id="center" class="light-pixel pixelArt"></div>
            <div id="center-line" class="dark-pixel pixelArt"></div>
            <div id="handle-container">
                <div id="slider-handle">
                    <div id="handle-top-side" class="dark-pixel pixelArt"></div>
                    <div id="handle-left-side" class="dark-pixel pixelArt"></div>
                    <div id="handle-center" class="color-pixel pixelArt"></div>
                    <div id="handle-center-line" class="dark-pixel pixelArt"></div>
                    <div id="handle-right-side" class="dark-pixel pixelArt"></div>
                    <div id="handle-bottom-side" class="dark-pixel pixelArt"></div>
                    <div id="handle-shadow" class="pixelArt"></div>
                </div>
            </div>
        </div>

        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 
            'size', 'w', 'h',
            'color', 'pixel-size', 'margin',
            'min', 'max', 'step', 'value',
            'value', 'signals', 'signal-out'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.sliderBackground = this.shadowRoot.querySelector('#slider-background');
        this.handleContainer = this.shadowRoot.querySelector('#handle-container');
        this.sliderHandle = this.shadowRoot.querySelector('#slider-handle');
        this.sensor = this.shadowRoot.querySelector('#sensor');
        this.signals = [];
        this.noClick = false;
        this.showFeedback = false;
        this.x = 0;
        this.y = 0;
        this.width = 50;
        this.height = 50;
        this.minX = 0;
        this.minX = 0;
        this.range = 0;
        this.pixelSize = 20;
        this.offsetX = 0;
        this.offsetY = 0;
        this.margin = 50;
        this.min = 0;
        this.max = 1;
        this.step = .1;
        this.value = 0;
        this.handleWidth = 0;
        this.color = '#ff0000';
        //if (this.signalsOut[0]) this.sendMessage('signal', this.signalsOut[0], this.value);
    }
  
    setup = async () => {
        this.observedMessages = [`${this.id}`];
        this.subscribe(this.observedMessages);
        this.subscribe(this.signals);  
        this.container.style.top = `${this.y}px`;
        this.container.style.left = `${this.x}px`;
        this.container.style.width = `${this.width}px`;
        this.container.style.height = `${this.height}px`;
        this.handleWidth = this.pixelSize * 7;

        await this.buildSlider();
       
        const rect = this.container.getBoundingClientRect();
        this.minX = rect.x + this.pixelSize + this.margin;
        this.maxX = rect.x + rect.width - this.pixelSize - this.margin;
        this.range = this.handleContainer.getBoundingClientRect().width;
        this.sensor.style.width = `${this.width + this.pixelSize * 2}px`;
        this.sensor.style.height = `${this.height + this.pixelSize * 2}px`;

        // set slider position from initial value
        this.setFromValue();

        this.shadowRoot.querySelector('#handle-center').style.backgroundColor = this.color;
        //const rect = this.container.getBoundingClientRect();
        //this.centerX = rect.left + rect.width / 2;
        //this.centerY = rect.top + rect.height / 2;
        if (!this.noClick) {
            this.addEventListener('pointerdown', this.handleClick);
            this.addEventListener('pointerdown', this.handleMessageOnClick);
        }
        this.addEventListener(`${this.id}`, this.handleEvent);
        this.broadcastMessage('register-sensor', this.id, this.container);
        //this.broadcastMessage('register-sensor', this.id, { x: this.x + this.w/2, y: this.y + this.h/2, w: this.w, h: this.height });
    }

    handleClick = (e) => {
        e.preventDefault();
        // Update center values dynamically in case layout shifted
        this.calculateValue(e.clientX, e.clientY);
        document.addEventListener('pointermove', this.dragElement);
        document.addEventListener('pointerup', this.endDragElement);
        document.addEventListener('pointerleave', this.endDragElement);
    }

    dragElement = (e) => {
        e.preventDefault();
        this.calculateValue(e.clientX + this.offsetX, e.clientY + this.offsetY);
    }

    endDragElement = () => {
        document.removeEventListener('pointermove', this.dragElement);
        document.removeEventListener('pointerup', this.endDragElement);
        document.removeEventListener('pointerleave', this.endDragElement);
    }

    handleEvent = (e) => {
        e.preventDefault();
        const type = e.detail.cmd;

        if (type === 'select') {
            this.sensor.style.backgroundColor = 'rgba(255, 255, 0, 0.5)';
        }
        if (type === 'unselect') {
            this.sensor.style.backgroundColor = 'rgba(255, 255, 255, 0)';
        }
        if (type === 'virtual-click') {
            this.handleMessageOnClick();
            let x = Number(e.detail.content.startX);
            let y = Number(e.detail.content.startY);
            this.offsetX = Number(e.detail.content.offsetX);
            this.offsetY = Number(e.detail.content.offsetY);
            const rect = this.container.getBoundingClientRect();
            this.calculateValue(x + this.offsetX, y + this.offsetY);
            document.addEventListener('pointermove', this.dragElement);
            document.addEventListener('pointerup', this.endDragElement);
            document.addEventListener('pointerleave', this.endDragElement);
        }
        if (type === 'virtual-drag') {
            this.calculateValue(e.clientX + this.offsetX, e.clientY + this.offsetY);
        }
        if (type === 'virtual-release') {
            this.offsetX = 0;
            this.offsetY = 0;
            document.removeEventListener('pointermove', this.dragElement);
            document.removeEventListener('pointerup', this.endDragElement);
            document.removeEventListener('pointerleave', this.endDragElement);
        }
    }

    teardown = () => {
        this.unsubscribe(this.signals);
        this.broadcastMessage('register-sensor', this.id);
        if (!this.noClick) {
            this.removeEventListener('pointerdown', this.handleClick);
        }
        this.removeEventListener(`${this.id}`, this.handleEvent);
    }
    
    calculateValue = (x, y) => {
        const rect = this.handleContainer.getBoundingClientRect();
        let startX = 0;
        let newX = x - rect.x;
        if ((newX >= startX) && (newX <= this.range + startX)) {
            this.sliderHandle.style.left = `${newX - (this.handleWidth /2)}px`;
            this.value = newX / this.range;
            this.value = this.map(this.value);
            this.sendMessage(this.signalOut, this.id, this.value);
        }
    }

    setFromValue = () => {
        const rect = this.handleContainer.getBoundingClientRect();
        let newX = (((this.value - this.min) / (this.max - this.min)) * this.range) - (this.handleWidth /2);
        this.sliderHandle.style.left = `${newX}px`;
        //this.sliderHandle.style.left = `${newX - this.handleWidth / 2}px`;
    }

    buildSlider = () => {
        let innerW = this.width - this.pixelSize * 2;
        let innerH = this.height - this.pixelSize * 2;
        let centerW = innerW - this.margin * 2;
        this.innerMax = centerW - this.margin;

        this.setPixelDimensions('top-side', innerW, this.pixelSize);
        this.setPixelDimensions('left-side', this.pixelSize, innerH);
        this.setPixelDimensions('bottom-side', innerW, this.pixelSize);
        this.setPixelDimensions('right-side', this.pixelSize, innerH );
        this.setPixelDimensions('left-margin', this.margin, innerH);
        this.setPixelDimensions('right-margin', this.margin, innerH);
        this.setPixelDimensions('center', centerW, innerH);
        this.setPixelDimensions('handle-container', centerW, innerH);
        this.setPixelDimensions('center-line', centerW, this.pixelSize);

        this.setPixelPosition('top-side', this.pixelSize, 0);
        this.setPixelPosition('left-side', 0, this.pixelSize);
        this.setPixelPosition('bottom-side', this.pixelSize, innerH + this.pixelSize);
        this.setPixelPosition('right-side', innerW + this.pixelSize, this.pixelSize);
        this.setPixelPosition('left-margin', this.pixelSize, this.pixelSize);
        this.setPixelPosition('right-margin', innerW + this.pixelSize - this.margin, this.pixelSize);
        this.setPixelPosition('center', this.margin + this.pixelSize, this.pixelSize);
        this.setPixelPosition('handle-container', this.margin + this.pixelSize, -(this.pixelSize * 2));
        this.setPixelPosition('center-line', this.margin + this.pixelSize, (this.height / 2) - this.pixelSize / 2);

        innerW = (this.pixelSize * 6) - this.pixelSize * 2;
        innerH = this.height + this.pixelSize * 2;
        
        this.sliderHandle.style.width = `${this.handleWidth}px`;
        this.setPixelDimensions('handle-top-side', innerW, this.pixelSize);
        this.setPixelDimensions('handle-left-side', this.pixelSize, innerH);
        this.setPixelDimensions('handle-bottom-side', innerW, this.pixelSize);
        this.setPixelDimensions('handle-right-side', this.pixelSize, innerH );
        this.setPixelDimensions('handle-center', innerW, innerH);
        this.setPixelDimensions('handle-shadow', innerW, this.pixelSize);
        this.setPixelDimensions('handle-center-line', (this.pixelSize), innerH - this.pixelSize * 2.5);

        this.setPixelPosition('handle-top-side', this.pixelSize, 0);
        this.setPixelPosition('handle-left-side', 0, this.pixelSize);
        this.setPixelPosition('handle-bottom-side', this.pixelSize, innerH + this.pixelSize);
        this.setPixelPosition('handle-right-side', innerW + this.pixelSize, this.pixelSize);
        this.setPixelPosition('handle-center', this.pixelSize, this.pixelSize);
        this.setPixelPosition('handle-shadow', this.pixelSize, innerH);
        this.setPixelPosition('handle-center-line', (innerW / 2) + (this.pixelSize / 2), this.pixelSize * 2);

        return new Promise(resolve => setTimeout(resolve, 500));

    }

    setPixelDimensions = (id, w, h) => {
        this.shadowRoot.querySelector(`#${id}`).style.width = `${w}px`;
        this.shadowRoot.querySelector(`#${id}`).style.height = `${h}px`;
    }

    setPixelPosition = (id, x, y) => {
        this.shadowRoot.querySelector(`#${id}`).style.top = `${y}px`;
        this.shadowRoot.querySelector(`#${id}`).style.left = `${x}px`;
    }
    
    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'size') {
            this.size = Number(newValue);
        }
        if (name === 'x') {
            this.x = Number(newValue);
        }
        if (name === 'y') {
            this.y = Number(newValue);
        }
        if (name === 'src') {
            this.src = newValue;
        }
        if (name === 'w') {
            this.width = Number(newValue);
        }
        if (name === 'h') {
            this.height = Number(newValue);
        }
        if (name === 'orientation') {
            this.orientation = newValue;
        }
        if (name === 'value') {
            this.value = Number(newValue);
        }
        if (name === 'signals') {
            this.signals = newValue.split(',');
        }
        if (name === 'signal-out') {
            this.signalOut = newValue;
        }
        if (name === 'no-click') {
            this.noClick = true;
        }
        if (name === 'show-feedback') {
            this.showFeedback = true;
        }
        if (name === 'color') {
            this.color = newValue;
        }
        if (name === 'pixel-size') {
            this.pixelSize = Number(newValue);
        }
        if (name === 'margin') {
            this.margin = Number(newValue);
        }
        if (name === 'min') {
            this.min = Number(newValue);
        }
        if (name === 'max') {
            this.max = Number(newValue);
        }
        if (name === 'step') {
            this.step = Number(newValue);
        }
        if (name === 'value') {
            this.value = Number(newValue);
        }
    }

    map = (value) => {
        const raw = value * (this.max - this.min) + this.min;
        const stepped = Math.round(raw / this.step) * this.step;
        const precision = Math.ceil(-Math.log10(this.step)) || 0;
        return parseFloat(stepped.toFixed(precision));
    }

}
